import type { AppDefinition } from '../../types/apps';

export const LocalFileAppDefinition: AppDefinition = {
  appId: 'local-file',
  name: 'Local File',
  version: '1.0.0',
  description: 'View local file system files',
  icon: {
    type: 'iconify',
    iconifyIcon: 'simple-icons:files',
  },
  events: {},
  entityTypes: [
    'LocalFile',
    'LocalMount',
    'External.LocalFile',
    'External.LocalFile.Directory',
  ],
  component: 'local-file',
  requiresProps: false,
  requiresEntity: true,
  actions: {},
  entityIcons: {
    LocalFile: {
      type: 'iconify',
      iconifyIcon: 'simple-icons:files',
    },
  },
};

export default LocalFileAppDefinition;

